"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEDIF = void 0;
exports.DATEDIF = {
    alias: 'DATA_DIF',
    description: 'Retorna a diferença entre as datas.',
    arg_names: ['data', 'data_a_comparar', 'formato'],
    args_description: [
        'data base',
        'data a ser comparada',
        'retorno em dias, meses, anos, hora, minuto, segundo',
    ],
    target_date_format: 'dd/MM/yyyy',
    source_date_format: 'yyyy-MM-dd',
    replacements: [
        null,
        null,
        {
            MONTH: 'MES',
            DAY: 'DIA',
            YEAR: 'ANO',
            HOUR: 'HORA',
            MINUTE: 'MINUTO',
            SECOND: 'SEGUNDO',
        },
    ],
};
